<style>
  @import url('https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css');
  @import url('https://fonts.googleapis.com/css?family=Material+Icons');
  @import url('https://unpkg.com/vue-form-wizard/dist/vue-form-wizard.min.css');
</style>

<template>
  <v-app id="voting-app" color="background">
    <div>
      <v-main>

        <router-view/>

      </v-main>
    </div>
  </v-app>
</template>

<script>
  export default {
    name: 'App',

    components: {
    },

    data: () => ({
    }),
    mounted() {
      let vueFormWzd = document.createElement('script');
      vueFormWzd.setAttribute('src', 'https://unpkg.com/vue-form-wizard/dist/vue-form-wizard.js');
      document.head.appendChild(vueFormWzd);
    },
  };
</script>



// WEBPACK FOOTER //
// src/App.vue